var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInt1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 153,
    viewBox: "0 0 153 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 51.1348,
    y: 40,
    width: 11.042,
    height: 26.3782,
    rx: 4,
    fill: "#BE9577"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.3613 68.67C52.3613 66.1816 53.8974 63.9514 56.2223 63.0643L73.4421 56.4936C74.8743 55.9471 76.4613 55.9695 77.8775 56.5562L93.4393 63.0032C95.6811 63.932 97.1428 66.1197 97.1428 68.5463V107C97.1428 110.313 94.4566 113 91.1428 113H58.3613C55.0476 113 52.3613 110.313 52.3613 107V68.67Z",
    fill: "#BE9577"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 74.9668L74.5 53.5L104.504 74.9668",
    stroke: "#9D6448",
    strokeWidth: 10.4286,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0586 96.3027C75.0586 92.989 77.7449 90.3027 81.0586 90.3027H81.9409C85.2547 90.3027 87.9409 92.989 87.9409 96.3027V113H75.0586V96.3027Z",
    fill: "#AD7C59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInt1);
export default __webpack_public_path__ + "static/media/int-1.e8a25273d795aaff0fb29a3f0984dbbc.svg";
export { ForwardRef as ReactComponent };